import React from 'react';
import { getMasterData, loadLanguageResource, activateAccount } from "../WSHelper/WSCallings";
import { changeLanguageString } from "../helper/AppLabels";
import { _Map, _isNull, Utilities, sendMessageToApp } from '../Utilities/Utilities';
import { LANGUAGE_OBJ, setValue,GameType, ALLOW_LANG } from '../helper/Constants';
import { createBrowserHistory } from 'history';
import CustomToast from "../Component/CustomComponent/Toast";
import CustomLoader from '../helper/CustomLoader';
import Routing from './Routing';
import ls from 'local-storage';
import WSManager from '../WSHelper/WSManager';
import * as WSC from "../WSHelper/WSConstants";
import { SetFantasyList } from '../JsonFiles/Sports';
import { withTranslation } from 'react-i18next';
import { parseAppMasterData } from '../Utilities/paseBackendData';
export const MyContext = React.createContext()

const history = createBrowserHistory();
const location = history.location;
const queryString = require('query-string');
const parsed = queryString.parse(location.search);

class MyProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            AppDataPosting: false
        }
    }

    getLanguageCode() {
        let lsLang = WSManager.getAppLang();
        let lang = lsLang ? lsLang.split('-') : (this.props.i18n && this.props.i18n.language) ? this.props.i18n.language.split('-') : ['en'];
        return lang[0];
    }

    loadResources = async (masterData) => {
        var l_code = this.getLanguageCode();
        let isCodeExist = false;
        _Map(masterData.l_list, (item) => {
            if (item == l_code && !isCodeExist) {
                isCodeExist = true;
            }
        })

        var param = { lang_code: isCodeExist ? l_code : masterData.default_lang };
        this.props.i18n.changeLanguage(param.lang_code);
        var api_response_data = await loadLanguageResource(param)
        if (api_response_data) {
            _Map(Object.keys(api_response_data), (key) => {
                LANGUAGE_OBJ[key] = api_response_data[key];
            })
        }
        else {
            import("../assets/i18n/translations/" + param.lang_code + ".json").then(data => {
                _Map(Object.keys(data), (key) => {
                    LANGUAGE_OBJ[key] = data[key];
                })
                changeLanguageString();
            });
        }
    }

    checkAppISLoggedIn(flag){
        if (window.ReactNativeWebView) {
            let data = {
                action: 'back',
                type: flag,
                targetFunc:'handleLoginReceived'
            }
            sendMessageToApp(data);
            this.handelNativeData();
        }
    }

    loadLangLocally(){
        var l_code = this.getLanguageCode();
        import("../assets/i18n/translations/" + l_code + ".json").then(data => {
            _Map(Object.keys(data), (key) => {
                LANGUAGE_OBJ[key] = data[key];
            })
            changeLanguageString();
        });
    }

    getSportNLangLocalList = (apiDATA) => {	
        if (apiDATA.fantasy_list) {	
            let data = {	
                default_sport: parseInt(apiDATA.default_sport || '7'),	
                url: {}	
            };	
            _Map(apiDATA.fantasy_list, (item) => {	
                let spID = parseInt(item.sports_id || '0');	
                let spName = ((item.en || item.sports_name) || '').toLowerCase();	
                data[spName] = spID;	
                data.url[spID] = spName;	
                _Map(apiDATA.l_list, (lObj) => {	
                    data.url[spID + (lObj || '')] = item[lObj];	
                })	
            })	
            SetFantasyList.FantasyList(data)	
        }
        if(apiDATA.l_list){
            let tmpAL = []
            _Map(ALLOW_LANG, (lObj) => {
                if(apiDATA.l_list.includes(lObj.value)){
                    tmpAL.push(lObj);
                }
            })
            setValue.setLanguage(tmpAL);
        }	
    }

    componentDidMount() {
        this.userAccountActivitaion();
    }
    
    userAccountActivitaion() {
        if (parsed && parsed.activation_key) {
            this.callUserAccountActivitaion(parsed.activation_key)
        }
    }

    callUserAccountActivitaion(activeKey) {
        let param = {
            "key": activeKey,
        }
        activateAccount(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                Utilities.showToast(responseJson.message, 3000);
            } else {
                Utilities.showToast(responseJson.global_error, 3000);
            }
        })
    }

    UNSAFE_componentWillMount() {
        this.checkAppISLoggedIn(false)
        this.loadLangLocally()
        let gameType = WSManager.getPickedGameType();
        setValue.setSelectedGameType(gameType || '');
        let whref = window.location.href;
        if (whref.includes('#prediction')) {
            WSManager.setPickedGameType(GameType.Pred);
            setValue.setGameTypesEnable(GameType.Pred);
            gameType = GameType.Pred;
        }
        if (whref.includes('#multigame')) {
            WSManager.setPickedGameType(GameType.MultiGame);
            setValue.setGameTypesEnable(GameType.MultiGame);
            gameType = GameType.MultiGame;
        }
        if(parsed.sgmty){
            let urlGT = atob(parsed.sgmty)
            WSManager.setPickedGameType(urlGT);
            setValue.setGameTypesEnable(urlGT);
            gameType = urlGT;
        }

        getMasterData().then((response_data) => {
            if (response_data) {
                // console.log(response_data);
                const api_response_data =  parseAppMasterData(response_data);
                // const api_response_data =  response_data;

                // console.log(api_response_data,'api_response_data');
                this.getSportNLangLocalList(api_response_data)
                if(process.env.REACT_APP_SERVE_LANG_LOCALLY != '1'){
                    this.loadResources(api_response_data).then(() => {
                        changeLanguageString();
                    });
                }
                const Data = api_response_data;
                const SHD = Data.sports_hub ? Data.sports_hub : []
                setValue.setCountryCodeData(Data.login_data);
                setValue.setOnlyCoinFlow(Data.coin_only);
                setValue.setMinDep(Data.min_dep);
                if (SHD.length > 1) {
                    setValue.setSportsHubAllow(true);
                } else {
                    setValue.setSportsHubAllow(false)
                }
                if (Data.otp_size) {
                    setValue.setOtpSize(Data.otp_size);
                }
                let appCacheVersion = ls.get('acv') || '';
                if (appCacheVersion && appCacheVersion !== Data.app_cache_version) {
                    WSManager.logout();
                } else {
                    ls.set('acv', Data.app_cache_version);
                    let apV = Data.app_version;
                    if (!apV || apV.length === 0) {
                        Data['app_version'] = '';
                        apV = ''
                    }
                    let downloadlinkData = apV && apV.android ? apV.android : {};
                    setValue.setAppDownloadLink(downloadlinkData.app_url)
                    let selectedSports = Utilities.getUrlSports();
                    Utilities.setMasterData(Data);
                    if (SHD.length === 1) {
                        WSManager.setPickedGameType(SHD[0].game_key);
                        setValue.setGameTypesEnable(SHD[0].game_key);
                    } else if (gameType) {
                        let isGameAllowed = false;
                        _Map(SHD, (item) => {
                            setValue.setGameTypesEnable(item.game_key);
                            if (item.game_key == gameType) {
                                isGameAllowed = true
                            }
                        })
                        if (!isGameAllowed) {
                            WSManager.removeLSItem('SHGT');
                        }
                    }else{
                        _Map(SHD, (item) => {
                            setValue.setGameTypesEnable(item.game_key);
                        })
                    }

                    if (selectedSports === "null") {
                        selectedSports = Data.default_sport;
                    }
                    this.setState({
                        AppDataPosting: true
                    }, () => {
                        changeLanguageString();
                    });
                    setTimeout(() => {
                        this.web_loaded();
                    }, 10);

                    if (_isNull(selectedSports) || selectedSports === Data.default_sport) {
                        ls.set('selectedSports', Data.default_sport);
                        setValue.setAppSelectedSport(Data.default_sport);
                    } else {
                        setValue.setAppSelectedSport(selectedSports);
                    }
                    let app_version = {
                        action: 'app_download',
                        targetFunc: 'app_download',
                        type: 'android',
                        data: apV.android || {}
                    }
                    sendMessageToApp(app_version)
                    this.handelNativeData();

                }
            }
        });
    }

    handelNativeData() {
        window.addEventListener('message', (e) => {
            if (e.data.action === 'app_version' && e.data.type === 'android') {
                Utilities.setAndroidAppVersion('' + e.data.version)
            }
            if(e.data.locale){
                WSManager.setAppLang(e.data.locale);
            }
            if (e.data.UserProfile) {
                WSManager.setProfile(e.data.UserProfile);
            } 
            if (e.data.LoginSessionKey) {
                WSManager.setToken(e.data.LoginSessionKey);
            }   
            if (e.data.isMobileApp) {
                WSManager.setIsMobileApp(e.data.isMobileApp);
            }  
            if (e.data.isIOSApp) {
                WSManager.setIsIOSApp(e.data.isIOSApp);
            }  
        });
    }

    web_loaded() {
        let webL = {
            action: 'web_loaded',
            targetFunc: 'web_loaded'
        }
        sendMessageToApp(webL)
    }

    appLoader = () => {
        if (WSManager.getIsIOSApp()) {
            return (
                <CustomLoader />
            )
        } else {
            return null
        }
    }

    render() {
        const {
            AppDataPosting
        } = this.state;

        return (
            <MyContext.Provider>
                <CustomToast style={{ zIndex: 999999 }} />
                {
                    (AppDataPosting)
                        ? <>{this.props.children}<Routing /></>
                        : window.ReactNativeWebView ? this.appLoader()
                        : <div className={"web-container white-bg"}><CustomLoader /></div>
                }
            </MyContext.Provider>
        )
    }
}

export default withTranslation()(MyProvider)